/**
 * The message our backend put in a failed response, or null when there is none worth showing.
 *
 * Our backend always answers with JSON. A request made with `responseType: 'blob'` receives that
 * JSON as a Blob, so it is read back as text first. String bodies are accepted only when they look
 * like a real message — reverse proxies (nginx/ALB/Cloudflare) return HTML pages on 502/503/504,
 * which would otherwise hijack the friendly fallbacks.
 */
export async function serverMessageFrom (data) {
  let body = data;
  if (typeof Blob !== 'undefined' && body instanceof Blob) {
    if (!body.type.includes('json')) return null;
    try {
      body = JSON.parse(await body.text());
    } catch (_) {
      return null;
    }
  }
  if (body && typeof body === 'object') {
    return body.message || body.error || null;
  }
  if (typeof body === 'string') {
    const trimmed = body.trim();
    const looksLikeMarkup = trimmed.startsWith('<');
    if (trimmed && !looksLikeMarkup && trimmed.length < 500) return trimmed;
  }
  return null;
}
